import { render, staticRenderFns } from "./SolutionArchitecture.vue?vue&type=template&id=13505dc8&scoped=true&"
import script from "./SolutionArchitecture.vue?vue&type=script&lang=js&"
export * from "./SolutionArchitecture.vue?vue&type=script&lang=js&"
import style0 from "./SolutionArchitecture.vue?vue&type=style&index=0&id=13505dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13505dc8",
  null
  
)

export default component.exports